"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryApiError = void 0;

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

class BasisTheoryApiError extends _extendableBuiltin(Error) {
  constructor(message, status, data, _debug) {
    super(message);
    this.status = status;
    this.data = data;
    this._debug = _debug;
    this.name = 'BasisTheoryApiError';
    Object.setPrototypeOf(this, BasisTheoryApiError.prototype);
  }

}

exports.BasisTheoryApiError = BasisTheoryApiError;